import { ForgotPassword } from '../../src/components'
import Footer from '../../src/components/Footer'
import Header from '../../src/components/Header'

export async function getServerSideProps({ req }) {
  return {
    props: {
    },
  };
}

export default function Index() {
  return (
    <>
      <Header />
      <div className="cure-inner-container">
        <ForgotPassword />
      </div>
      <Footer />
    </>
  )
}
